import { isVar } from './isVar';

function createConverter(units: string) {
  return (px: unknown) => {
    if (typeof px === 'number') {
      return `calc(${px / 16}${units} * var(--scale))`;
    }

    if (typeof px === 'string') {
      if (isVar(px)) {
        return `calc(${px}/16 * 1${units} * var(--scale))`;
      }

      const replaced = px.replace('px', '');
      if (!Number.isNaN(Number(replaced))) {
        return `calc(${Number(replaced) / 16}${units} * var(--scale))`;
      }
    }

    return px as string;
  };
}

export const rem = createConverter('rem');
export const em = createConverter('em');
